import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import React, {useState} from "react";
import PropTypes from "prop-types";
import {toast} from "react-toastify";
import {axios_tenant} from "../../../axios";

const SLAUpdateModal = ({ open, onClose, request, loadRequests }) => {
    const [additionalHours, setAdditionalHours] = useState("")
    const [loading, setLoading] = useState(false);

    if (!request) return null

    const now = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
    const requestTime = new Date(request.slaTime).toLocaleString("en-US", { timeZone: "America/New_York" });
    const nowTime = new Date(now);
    const requestTimeEST = new Date(requestTime);
    const hours = Math.ceil((requestTimeEST.getTime() - nowTime.getTime()) / (1000 * 60 * 60));
    const minutes = requestTimeEST.getMinutes();
    const hour = requestTimeEST.getHours() > 12 ? requestTimeEST.getHours() - 12 : requestTimeEST.getHours();
    const ampm = requestTimeEST.getHours() >= 12 ? 'PM' : 'AM';

    const parsedHours = parseInt(additionalHours, 10);
    const hasValidHours = Number.isInteger(parsedHours) && parsedHours > 0;

    const handleSubmit = async () => {
      if (!hasValidHours) {
        toast.error("Please enter the number of hours to extend the SLA by")
        return
      }
      try {
        setLoading(true);
        // Add additionalHours to the request's slaTime timestamp
        const newSlaTime = new Date(request.slaTime)
        newSlaTime.setHours(newSlaTime.getHours() + parsedHours)
        await axios_tenant.put(`/reference-downloader/requests/sla/${request.requestId}`, { slaTime: newSlaTime.toISOString() })
        toast.success("SLA Updated Successfully")
        onClose()
        loadRequests()
      } catch (error) {
        toast.error("Error updating SLA")
        console.error("Failed to update SLA", error)
      } finally {
        setLoading(false);
      }
    };

    return (
      <Modal open={open} onClose={onClose} aria-labelledby="sla-update-modal-title">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
          }}
        >
          <Typography id="sla-update-modal-title" variant="h2" component="h2" sx={{ mb: 2 }}>
            Update SLA
          </Typography>
  
        <Box 
            sx={{ 
                display: "flex", 
                alignItems: "center",
                bgcolor:"rgb(245, 244, 207)",
                p: 1,
                mb: 2,
            }}>
            <Info fontSize="small" sx={{ mr: 1 }} />
            Ensure the new time reflects the increased workload.
        </Box>

  
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Current Completion Time:
            </Typography>
            <Typography variant="body1" color="error">
              {
              //  `${hours} hours (by ${hour}:${minutes < 10 ? '0' + minutes : minutes} ${ampm} EST)`
              `${hours} hours (By ${new Date(requestTimeEST).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}, ${hour}:${minutes < 10 ? '0' + minutes : minutes} ${ampm} EST)`
              }
            </Typography>
          </Box>
  
          <Box sx={{ mb: 3 }}>
            {/* <Typography variant="body2" color="text.secondary" gutterBottom>
              Increase SLA by:
            </Typography> */}
            <TextField
              type="number"
              value={additionalHours}
              onChange={(e) => {
                const value = e.target.value;
                if (value < 0) return;
                setAdditionalHours(value);
              }}
              label="Increase SLA by (hours)"
              // fullWidth
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            />
          </Box>
  
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSubmit} disabled={loading || !hasValidHours}>
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    )
  }

SLAUpdateModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  loadRequests: PropTypes.func,
  request: PropTypes.shape({
    requestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slaTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  }),
};

export default SLAUpdateModal;